import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incubatee-page',
  templateUrl: './incubatee-page.component.html',
  styleUrls: ['./incubatee-page.component.css']
})
export class IncubateePageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
